import { Component, inject, OnInit } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { Router } from '@angular/router';
import { IUserCognito, UserService } from '../../shared/services/user.service';
import { AuthService } from './auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  private readonly oidcSecurityService = inject(OidcSecurityService);
  private router = inject(Router);
  private userService = inject(UserService);
  private authService = inject(AuthService);

  ngOnInit(): void {
    if (window.location.hash === '#_=_') {
      history.replaceState(null, '', window.location.href.split('#')[0]);
    }
    this.oidcSecurityService.checkAuth().subscribe(({isAuthenticated, userData}) => {
      console.warn('Authenticated:', isAuthenticated);
      console.log('userData', userData);
      console.log('isAuthenticated', isAuthenticated);

      if (isAuthenticated && userData?.email) {
        // Обновляем Cognito данные пользователя в сервисе
        this.userService.setUserCognito(userData as IUserCognito);
        // После авторизации загружаем профиль по email или cognitoId
        this.userService.loadUserProfile().subscribe(({isNewUser}) => {
          void this.router.navigate([isNewUser ? '/profile-setup' : '/dashboard']);
        });
      } else {
        this.authService.logout();
      }
    });
  }
}
